import React, { useState } from "react";
import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import Select from "react-select";
import { Link } from "react-router-dom";
import { TextMediumSM } from "../../../Components/Text/MediumText";

function ReportMainIndex() {
  const [selectedValues, setSelectedValues] = useState("");
  const [show, setShow] = useState("");

  function handleChange(e) {
    setSelectedValues(e.value);
  }

  const styles = {
    control: (provided) => ({
      ...provided,

      border: "1px solid #e5e5e5",
      outline: "none",
      borderRadius: "10px",
      padding: "0",
      color: "#000",
      textAlign: "left",
      // fontSize:'13px',
      fontWeight: "500",
      width: "100%",
      // zIndex:0
    }),
  };

  let ProcurementOptions = [
    {
      label: "Cost Saving Analysis",
      value: 1,
      link: "/reports/procurement/cost-saving-analysis",
    },
    {
      label: "Purchase Order",
      value: 1,
      link: "/reports/procurement/purchase-order",
    },
    {
      label: "YPR",
      value: 1,
      link: "/reports/procurement/ypr",
    },
    {
      label: "RFQ",
      value: 1,
      link: "/reports/procurement/rfq",
    },
  ];

  let SalesOptions = [
    {
      label: "Customer Quote",
      value: 1,
      link: "/reports/sales/customer-quote",
    },
  ];
  // let SalesOptions = [];

  function handleSubmit() {
    if (selectedValues) {
      setShow(selectedValues);
    } else {
      setShow("");
    }
  }

  return (
    <div className="w-full h-full px-2 sm:px-4 py-2 overflow-hidden">
      <Breadcrumb
        items={[
          {
            name: "Report",
          },
        ]}
      />
      <div className="w-full h-[calc(100vh-130px)] mt-2 bg-white rounded-lg overflow-y-auto p-3 shadow-sm">
        <p className="w-full text-center font-semibold mb-2 text-base sm:text-lg text-slate-800">
          Reports
        </p>
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          <div className="w-full">
            <p className="px-4 py-1 bg-baseColor-primary text-white font-semibold text-sm sm:text-base mb-3 rounded-lg text-center shadow-sm">
              Procurement
            </p>
            <div className="flex flex-col gap-2">
              {ProcurementOptions &&
                ProcurementOptions.map((item, index) => {
                  return (
                    <Link
                      key={index}
                      to={item.link}
                      className="w-full bg-slate-50 border border-slate-100 p-2 flex items-center justify-between rounded-lg hover:bg-slate-100 hover:shadow-md active:scale-[0.99] transition-all duration-150 group"
                    >
                      <TextMediumSM content={item.label || ""} />
                    </Link>
                  );
                })}
            </div>
          </div>
          <div className="w-full">
            <p className="px-4 py-1 bg-baseColor-primary text-white font-semibold text-sm sm:text-base mb-3 rounded-lg text-center shadow-sm">
              Sales
            </p>
            <div className="flex flex-col gap-2">
              {SalesOptions &&
                SalesOptions.map((item, index) => {
                  return (
                    <Link
                      key={index}
                      to={item.link}
                      className="w-full bg-slate-50 border border-slate-100 p-2 flex items-center justify-between rounded-lg hover:bg-slate-100 hover:shadow-md active:scale-[0.99] transition-all duration-150 group"
                    >
                      <TextMediumSM content={item.label || ""} />
                    </Link>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReportMainIndex;
